import React, { useState, useEffect } from 'react';
import './inquiry.css';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../utils/config';

const Inquiry = () => {
    const navigate = useNavigate();

    const [inquiry, setInquiry] = useState({
        fullName: '',
        email: '',
        phone: '',
        nationality: '',
        tourId: '',
        guestSize: '1',
        fromDate: '',
        toDate: ''
    });

    const [tours, setTours] = useState([]);

    useEffect(() => {
        const fetchTours = async () => {
            try {
                const response = await fetch(`${BASE_URL}/tours`);
                const data = await response.json();
                if (data.success && Array.isArray(data.data)) {
                    setTours(data.data);
                } else {
                    console.error("Tours data is not in expected format:", data);
                }
            } catch (error) {
                console.error("Failed to fetch tours:", error);
            }
        };
        fetchTours();
    }, []);

    const handleChange = e => {
        const { id, value } = e.target;
        if (id === 'tourId') {
            const selectedTour = tours.find(tour => tour._id === value);
            setInquiry(prev => ({
                ...prev,
                tourId: selectedTour._id,
                tourName: selectedTour.title  // Assuming the title field holds the tour name
            }));
        } else {
            setInquiry(prev => ({ ...prev, [id]: value }));
        }
    };
    

    const handleSubmit = async e => {
        e.preventDefault();

        try {
            const response = await fetch(`${BASE_URL}/inquiry`, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(inquiry)
            });

            const result = await response.json();
            if (!response.ok) {
                throw new Error(result.message || 'Something went wrong');
            }

            navigate('/thank-you'); // Redirect or show a success message
        } catch (err) {
            alert(err.message);
        }
    };

    return (
        <div className='inquiry'>
            <div className="inquiry__form">
                <h5>Information</h5>
                <Form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label for="fullName">Full Name</Label>
                        <Input type="text" id="fullName" required onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="email">Email</Label>
                        <Input type="email" id="email" required onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="phone">Phone</Label>
                        <Input type="number" id="phone" required onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="nationality">Nationality</Label>
                        <Input type="text" id="nationality" required onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="tourId">Choose a tour</Label>
                        <Input type="select" id="tourId" required onChange={handleChange}>
                            {tours && tours.length > 0 ? (
                                tours.map(tour => (
                                    <option key={tour._id} value={tour._id}>{tour.title}</option>
                                ))
                            ) : (
                                <option disabled>Loading tours...</option>
                            )}
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="guestSize">Number of Guests</Label>
                        <Input type="select" id="guestSize" required onChange={handleChange}>
                            {[...Array(7).keys()].map(n => (
                                <option key={n + 1} value={n + 1}>{n + 1}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup className='d-flex align-items-center gap-3'>
                        <Label className="mr-2">From Date:</Label>
                        <Input type="date" id='fromDate' required onChange={handleChange} />
                       
                    </FormGroup>
                    <FormGroup className='d-flex align-items-center gap-3'>
                    <Label className="ml-4 mr-2">To Date:</Label>
                    <Input type="date" id='toDate' required onChange={handleChange} />
                    </FormGroup>
                    <Button className='btn primary__btn w-100 mt-4'>Inquire Now</Button>
                </Form>
            </div>
        </div>
    );
};

export default Inquiry;
